import { takeLatest, call, put } from 'redux-saga/effects';
import * as signupActions from 'redux/ducks/signup/signupDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import empSearchNoSessionApi from 'api/employee/empSearchNoSessionApi';

export function* getNoSessionRegister({ payload }) {
  try {
    const response = yield call(empSearchNoSessionApi.getNoSessionRegister, payload);
    yield put(signupActions.getNoSessionRegisterSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getNoSessionGlobalPosition({ payload }) {
  try {
    const response = yield call(empSearchNoSessionApi.getNoSessionGlobalPosition, payload);
    yield put(signupActions.getNoSessionGlobalPositionSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getTelCodeList({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getTelCodeList, payload);
    yield put(signupActions.getTelCodeListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getAddressNationList({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getAddressNationList, payload);
    yield put(signupActions.getAddressNationListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addEmp({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.addEmp, payload);
    yield put(signupActions.addEmpSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCheckOTP({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getCheckOTP, payload);
    yield put(signupActions.getCheckOTPSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getDoubleCheck({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getDoubleCheck, payload);
    yield put(signupActions.getDoubleCheckSuccess(response));
    yield put(alertActions.open({ message: ['MB_M_CHANGID_VALIDATED'] }));
  } catch (error) {
    yield put(signupActions.getDoubleCheckFail());
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getValidate({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getValidate, payload);
    yield put(signupActions.getValidateSuccess(response));
    yield put(signupActions.setUserId(payload.query));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* modifyEmp({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.modifyEmp, payload);
    yield put(signupActions.modifyEmpSuccess(response));
  } catch (error) {
    if (error.errorMessage && error.errorMessage.length > 0)
      yield put(alertActions.open({ message: [{ textMgs: error.errorMessage }] }));
    else yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* signupSaga() {
  yield takeLatest(signupActions.getNoSessionRegister, getNoSessionRegister);
  yield takeLatest(signupActions.getNoSessionGlobalPosition, getNoSessionGlobalPosition);
  yield takeLatest(signupActions.getTelCodeList, getTelCodeList);
  yield takeLatest(signupActions.getAddressNationList, getAddressNationList);
  yield takeLatest(signupActions.addEmp, addEmp);
  yield takeLatest(signupActions.getCheckOTP, getCheckOTP);
  yield takeLatest(signupActions.getDoubleCheck, getDoubleCheck);
  yield takeLatest(signupActions.getValidate, getValidate);
  yield takeLatest(signupActions.modifyEmp, modifyEmp);
}
